import http from './http'
import type { Product } from '../types/product'

export type Paginated<T> = {
	data: T[]
	current_page: number
	last_page: number
	total: number
}

export async function listProducts(
  q?: string,
  perPage: number = 18,
  page: number = 1,
  sort?: string,
  dir?: 'asc' | 'desc',
  min_price?: number,
  max_price?: number,
  category?: string
): Promise<Paginated<Product>> {
  const params: any = { per_page: perPage, page }
  if (q) params.q = q
  if (category) params.category = category
  if (sort) params.sort = sort
  if (dir) params.dir = dir
  if (min_price != null) params.min_price = min_price
  if (max_price != null) params.max_price = max_price
  const res = await http.get('/api/products', { params })
  return res.data
}

export async function listPartners(): Promise<{ data: Array<{ name: string; logo_path: string; url?: string }> }> {
  const res = await http.get('/api/partners', { params: { t: Date.now() } })
  return res.data
}


export async function getProductBySlug(slug: string): Promise<Product> {
	const res = await http.get(`/api/products/${slug}`)
	return res.data
}


